import React from "react"


import { Splitter, SplitterPanel } from 'primereact/splitter';
import { TabView, TabPanel } from 'primereact/tabview';
import DocumentView from "../../../common/DocumentView";

import "../index.css"

const BuyerPOAndInvoiceSplitView = (props) => {
    const { buyerPOPdfURL, buyerPODocProof } = props

    const renderPDF = (pdfURL) => {
        return (
            <>
                {
                    pdfURL ?
                        <DocumentView fileUrl={pdfURL} showZoomControl={true}/>
                        : <p className='text-center'>The pdf file is not found</p>
                }
            </>
        )
    }

    return (
        <div className="">
            {
                <TabView className="mt-1 invoice-tabview">
                    <TabPanel header="Client PO Doc & Invoice">
                        <div style={{ height: 'calc(100vh - 100px)' }}>
                            <Splitter style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                                <SplitterPanel style={{ width: '50%', height: '80%', overflow: 'auto' }} className="">
                                    {
                                        buyerPODocProof?.includes('.pdf') ? renderPDF(buyerPODocProof) :
                                            <iframe title='pdf viewer' src={buyerPODocProof} style={{ width: '100%', height: '100%', border: 'none' }} />
                                    }
                                </SplitterPanel>
                                <SplitterPanel style={{ width: '50%', height: '80%', overflow: buyerPODocProof?.includes('.pdf') ? 'auto' : 'hidden' }} className="">
                                    <div style={{ maxWidth: "50vw", height: '100%', width: "100%" }}>
                                        {props.renderHTMLInvoiceDocument()}
                                    </div>
                                </SplitterPanel>
                            </Splitter>
                        </div>
                    </TabPanel>
                    <TabPanel header="BuyerPO & Invoice">
                        <div style={{ height: 'calc(100vh - 100px)' }}>
                            <Splitter style={{ width: '100%', height: '100%', overflow: 'hidden' }}>
                                <SplitterPanel size={50} style={{ width: '50%', height: '80%', overflow: 'auto' }} className="">
                                    {buyerPOPdfURL && renderPDF(buyerPOPdfURL)}
                                </SplitterPanel>
                                <SplitterPanel style={{ width: '50%', height: '80%', overflow: 'hidden' }} className="">
                                    <div style={{ height: '100%', width: "100%" }}>
                                        {props.renderHTMLInvoiceDocument()}
                                    </div>
                                </SplitterPanel>
                            </Splitter>
                        </div>
                    </TabPanel>
                </TabView>
            }
        </div>
    )
}

export default BuyerPOAndInvoiceSplitView